import { logger } from '@getvim/vim-connect-logger';

export const loginWidgetLogger = logger.scope('Login widget', {
  moduleAndScopeSameColor: true,
  moduleName: 'Login',
});
